export default "__VITE_ASSET__BUba_e23__"